import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../api.service';
import { ProfileRefreshService } from '../profile-refresh.service';

@Component({
  selector: 'app-work-and-social',
  templateUrl: './work-and-social.component.html',
  styleUrls: ['./work-and-social.component.css']
})
export class WorkAndSocialComponent implements OnInit {

  user = {
    state: '',
    user_id: 0,
    firstname: '',
    lastname: '',
    email: '',
    DOB: null,
    city: null,
    country: null,
    company: null,
    job_title: null,
    website: null,
    facebook_url: null,
    twitter_url: null,
    linkedin_url: null,
    youtube_url: null,
    profile_image: null,
    gender: null,
    business_type: '',
    sport_type: '',
    position: '',
    age_type: ''
  };
  isLoading = false;
  saving = false;
  saveMsg = '';
  saveOk = true;

  constructor(private apiService: ApiService, private refresh: ProfileRefreshService) {}

  ngOnInit(): void {
    const id = localStorage.getItem('user_id');
    if (!id) { return; }

    this.isLoading = true;
    this.user.user_id = parseInt(id, 10);

    this.apiService.getUserById(this.user.user_id).subscribe(
      (response) => {
        const updatedUser = {
          firstname: response.Users.firstname,
          lastname: response.Users.lastname,
          email: response.Users.email,
          DOB: response.Users.DOB,
          city: response.Users.city,
          country: response.Users.country,
          company: response.Users.company,
          job_title: response.Users.job_title,
          website: response.Users.website,
          facebook_url: response.Users.facebook_url,
          twitter_url: response.Users.twitter_url,
          linkedin_url: response.Users.linkedin_url,
          youtube_url: response.Users.youtube_url,
          profile_image: response.Users.profile,
          gender: response.Users.gender,
          business_type: response.Users.business_type,
          sport_type: response.Users.sport_type,
          position: response.Users.position,
          age_type: response.Users.age_type,
          state: response.Users.state,
        };
        this.user = { ...this.user, ...updatedUser };
        this.isLoading = false;
      },
      (error) => {
        console.error('Error fetching user:', error);
        this.isLoading = false;
      }
    );
  }

  saveChanges() {
    this.saving = true;
    this.saveMsg = '';
    this.apiService.updateUser(this.user).subscribe(
      () => {
        this.saving = false;
        this.saveOk = true;
        this.saveMsg = 'Saved successfully';
        this.refresh.ping();
      },
      (error) => {
        console.error('Error updating user data:', error);
        this.saving = false;
        this.saveOk = false;
        this.saveMsg = 'Could not save changes';
      }
    );
  }
}
